module.exports = "<div class=\"modal-footer clear\" ng-if=\"hasPerms()!==undefined\"> <a class=\"btn btn-icon btn-default\" ng-click=cancel() ng-if=hasPerms()> <i class=\"fa fa-reply\"></i> {{ 'jdro_common.cancel' | translate }} </a> <a class=\"btn btn-icon btn-default\" ng-click=cancel() ng-if=!hasPerms()> <i class=\"fa fa-reply\"></i> {{ 'jdro_common.retry' | translate }} </a> <button type=submit class=\"btn btn-icon btn-primary\" ng-click=\"submitted = true\" ng-if=hasPerms()> <i class=\"fa fa-paper-plane-o\"></i> {{ 'jdro_common.save' | translate }} </button> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/formButton.html
// module id = 381
// module chunks = 0